module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/144.7c3568f0.png";